module.exports = __webpack_public_path__ + "img/ordF1.7a6a3d0d.jpg";